<template>
  <div :class="classes">
      <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" :refresh="false"  :isAddPageToRouter="true">
       <wt-table :list="tableData" :labels="tableLabels">
          <template>
            <slot/>
          </template>
      </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-roles-table'

export default {
  name: 'pt-roles-table',
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
